import { gql } from 'graphql-request';
import { tokenAppGraphql, loginServiceGraphql } from '../config/Config';

export const genTokenApp = async (data) => {
  const GEN_TOKEN_APP = gql`
    mutation GenTokenApp($data: GenTokenAppInput!) {
      genTokenApp(data: $data) {
        id
        app_id
        token
        type
        access_to
      }
    }
  `;

  const response = await tokenAppGraphql.request(GEN_TOKEN_APP, data);
  return response.genTokenApp;
};

export const verifyPhoneLogin = async (data) => {
  const PHONE = gql`
    mutation VerifyPhoneAndGenerateOtp($phone: String!) {
      verifyPhoneAndGenerateOtp(phone: $phone) {
        id
        phone
        code
        status
        authentype
        isHasPass
      }
    }
  `;

  const response = await loginServiceGraphql.request(PHONE, data);
  return response.verifyPhoneAndGenerateOtp;
};

export const verifyOtp = async (data) => {
  const VERIFY_OTP = gql`
    mutation VerifyOtp($data: VerifyOtpInput!) {
      verifyOtp(data: $data) {
        phone
        status
        type
      }
    }
  `;

  const response = await loginServiceGraphql.request(VERIFY_OTP, data);
  return response.verifyOtp;
};

export const loginGraphql = async (data) => {
  const LOGIN = gql`
    mutation LoginEmployee($data: EmployeeLoginInput!) {
      loginEmployee(data: $data) {
        token
        role
        phone
        username
        fullname
      }
    }
  `;

  const response = await loginServiceGraphql.request(LOGIN, data);
  return response.loginEmployee;
};
